const SERVICE = {
  //#region USER
  USER: '/user/api/v1.0/user',
  CONTACT: '/user/api/v1.0/contact',
  INVITE: '/user/api/v1.0/invite',
  AUTH: '/user/api/v1.0/authentication',
  AUTHORIZATION: '/user/api/v1.0/authorization',
  ACCOUNT: '/user/api/v1.0/account',
  ORGANIZATION: '/user/api/v1.0/organization',
  BUSINESS_PROFILES: '/user/api/v1.0/businessprofiles',
  USER_SMART_INSIGHT: '/user/api/v1.0/smartinsight',
  ORGANIZATION_CUSTOMIZATION: '/user/api/v1.0/organizationcustomization',

  API: '/api/api/v1.0/apikey',
  //#endregion

  //#region AUDIENCE
  AUDIENCE: '/audience/api/v1.0/audience',
  SEGMENTS: '/audience/api/v1.0/segments',
  DEFAULT: '/audience/api/v1.0/default',
  //#endregion

  //#region SENDER
  SENDER: '/sender/api/v1.0/sms',
  SENDER_DOMAIN: '/sender/api/v1.0/domains',
  SENDER_USER: '/sender/api/v1.0/usersenders',
  ORGANIZATION_SENDERS: '/sender/api/v1.0/organizationsenders',
  //#endregion

  //#region TEMPLATE
  TEMPLATE_EMAIL: '/template/api/v1.0/email',
  TEMPLATE_SMS: '/template/api/v1.0/sms',
  TEMPLATE_DEFAULT_EMAIL: '/template/api/v1.0/defaultemailtemplates',
  //#endregion

  //#region CAMPAIGN
  CAMPAIGN: '/campaign/api/v1.0/campaign',
  CAMPAIGN_TRANSACTIONS: '/campaign/api/v1.0/transaction',
  CAMPAIGN_CHANNELS: '/campaign/api/v1.0/channels',
  CAMPAIGN_ENGAGEMENT: '/campaign/api/v1.0/engagementmetrics',
  CAMPAIGN_RESULTS: '/campaign/api/v1.0/campaignresults',
  CAMPAIGN_REPORTS: '/campaign/api/v1.0/reports',
  CAMPAIGN_TWO_WAY_MESSAGING: '/campaign/api/v1.0/twowaymessaging',
  CAMPAIGN_RECIPIENTS: '/campaign/api/v1.0/recipients',
  //#endregion

  //#region BALANCES
  BALANCES: '/balance/api/v1.0',
  BALANCE_TRANSACTIONS: '/balance/api/v1.0/transactions',
  BALANCE_PAYMENT: '/balance/api/v1.0/payment',
  BALANCE_PAYMENT_METHOD: '/balance/api/v1.0/paymentMethod',
  BALANCE_PAYMENT_ADDON: '/balance/api/v1.0/paymentaddon',
  BALANCE_ORGANIZATION_PLANS: '/balance/api/v1.0/organizationplans',
  BALANCE_PLAN_CANCELATION_REASON: '/balance/api/v1.0/plancancellationreasons',
  BALANCE_INVOICES: '/balance/api/v1.0/invoices',
  BALANCE_CONTACT: '/balance/api/v1.0/contact',
  //#endregion

  BALANCE_ADDORECURRENTSMS: '/balance/api/v1.0/addonrecurrentsms',
  BALANCE_ADDORECURRENTEMAIL: '/balance/api/v1.0/addonrecurrentemail',
  BALANCE_PROMOTION: '/balance/api/v1.0/promotion',
  BALANCE_PLAN: '/balance/api/v1.0/plan',

  //#region NOTIFICATION
  NOTIFICATION_CONTACT: 'notification/api/v1.0/contact',
  //#endregion

  //#region AUTOMATION
  AUTOMATION: 'automation/api/v1.0/automation',
  //#endregion
}

export default SERVICE
